<script>
	import { Modal, ModalBody, ModalHeader } from "sveltestrap";
	import { loading, errorMessage, evLogIds } from "../../../store/store";
	import { onDestroy } from "svelte";

	import EvLogTable from "./RecentUpdatesTable.svelte";
	import client from "../../../services/client";
	import { extractErrorMessage } from "../../../utils/misc";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	export let showModal;

	let data = [];

	// Fetch data only when showModal is true
	$: showModal && fetchData();

	const fetchData = async () => {
		try {
			errorMessage.set("");
			const res = await client(`/v1/evLog/getByIds`, {
				method: "POST",
				version: "evCharging",
				data: { evLogIds: $evLogIds },
			});

			data = res.data.data;
			loading.set(false);
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
			console.log(err.response);
		}
	};

	function toggleModal() {
		showModal = false;
		// Reload only after closing the modal
		// setTimeout(() => window.location.reload(), 0);
	}
</script>

<Modal isOpen={showModal} backdrop size={"lg"} toggle={toggleModal}>
	<ModalHeader toggle={toggleModal}>
		<h4 class="font-weight-bold">Ev charging lots recent updates</h4>
	</ModalHeader>
	<ModalBody>
		<div>
			<ErrorMessageHandler message={$errorMessage} />
		</div>
		<EvLogTable {data} />
	</ModalBody>
</Modal>

<style>
	:global(.modal-backdrop.show) {
		opacity: 0.5; /* Adjust opacity for desired transparency */
	}
</style>
